import React from "react";
import styles from "./EmptyState.module.scss";
import { combineClasses } from "@/lib/utils";

interface EmptyStateProps {
  message?: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ message = "No data found", className }) => (
  <div className={combineClasses(styles.emptyState, className || "")}>
    <img src="/data%20not%20found.png" alt="No data found" className={styles.image} />
    <h1 className={styles.message}>{message}</h1>
  </div>
);

export default EmptyState;
